import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  message: string;
  subtitle?: string;
}

export const EmptyState = ({ icon: Icon, message, subtitle }: EmptyStateProps) => {
  return (
    <div className="text-center py-8">
      {Icon && (
        <div className="flex justify-center mb-4">
          <Icon className="text-border-muted" size={48} />
        </div>
      )}
      <p className="text-sm text-muted-foreground">
        {message}
      </p>
      {subtitle && (
        <p className="text-xs text-border-muted mt-2">
          {subtitle}
        </p>
      )}
    </div>
  );
};
